import { noAccessText } from '../../constants/constants';
import React from 'react';
const Button = ({
  text,
  onClick,
  className,
  actionBtn = false,
  secondary = false,
  disabled = false,
  smallBtn = false,
  style,
  icon,
  iconPosition = 'start',
  iconSize = null,
  type,
  plain = false,
  title,
  titleMessage,
}) => {
  const baseStyles =
    'flex items-center justify-center border border-primary-color whitespace-nowrap overflow-hidden text-ellipsis rounded-[6px]';
  const sizeStyles = smallBtn
    ? 'h-[38px] text-[16px] font-[500] px-[20px] font-primaryRegular'
    : 'h-[50px] text-[18px] leading-[30px] px-4';

  let stateStyles = '';

  if (plain) {
    stateStyles = 'bg-transparent border-none shadow-none hover:bg-transparent';
  } else if (disabled) {
    stateStyles =
      'bg-white-color text-primary-color hover:bg-white-color opacity-50 cursor-default';
  } else if (actionBtn) {
    stateStyles = 'bg-primary-color text-white-color hover:bg-primary-bgColor';
  } else if (secondary) {
    stateStyles = 'bg-white-color text-primary-color hover:bg-white-color';
  } else {
    stateStyles = 'bg-primary-color text-white-color hover:bg-primary-bgColor';
  }

  const iconGap = icon ? 'gap-2' : '';
  const finalClassName = `${baseStyles} ${sizeStyles} ${stateStyles} ${iconGap} ${className || ''}`;

  return (
    <button
      title={titleMessage ? titleMessage : title && `${noAccessText} ${title}`}
      type={type}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        onClick?.(e);
      }}
      style={style}
      className={finalClassName}
    >
      {icon && iconPosition === 'start' && (
        <img
          src={icon}
          alt='Icons'
          style={{ width: iconSize, height: iconSize }}
          className={`${smallBtn ? 'w-[15px]' : 'w-[20px]'} 
            ${secondary ? 'filter-none' : 'filter brightness-0 invert'}`}
        />
      )}
      {text}
      {icon && iconPosition === 'end' && (
        <img
          src={icon}
          alt='Icons'
          style={{ width: iconSize, height: iconSize }}
          className={`${smallBtn ? 'w-[15px]' : 'w-[20px]'} 
            ${secondary ? 'filter-none' : 'filter brightness-0 invert'}`}
        />
      )}
    </button>
  );
};

export default Button;
